import { FC, ReactNode } from 'react'

/* limit content width and align content center */
export const LimitContentWidth: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  if (!children) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          width: '100%',
        }}
      >
        {children}
      </div>
    </div>
  )
}
